<template>
  <!-- <section>
    <button @click="playVideo">play</button>
  </section>-->

  <section class="hero-temporario">
    <div class="hero-image-container">
      <img src="/images/hero-temporario.jpg" />
    </div>

    <div class="botoes">
      <v-btn dark round color="orange darken-1" href="/matriculas"
        >Matrículas</v-btn
      >
      <v-btn dark round color="blue darken-1" href="/institucional/calendario"
        >Calendário</v-btn
      >
      <br class="hidden-sm-and-up" />
      <v-btn
        dark
        round
        color="blue darken-1"
        href="/institucional/espaco-fisico"
        >Estrutura</v-btn
      >
      <v-btn
        dark
        round
        color="blue darken-1"
        href="/institucional/lista-de-materiais"
        >Materiais</v-btn
      >
    </div>
  </section>
</template>

<script>
export default {
  data: () => ({}),
  methods: {},
  computed: {}
};
</script>

<style lang="scss" scoped>
.hero-image-container {
  display: flex;

  img {
    width: 100%;
    /* height: 60vw; */
    object-fit: cover;
    object-position: right bottom;
  }

  @media (min-width: 880px) {
    img {
      height: auto;
    }
  }
}

.botoes {
  text-align: center;
  padding: 20px;
  margin-top: -45px;

  .v-btn {
    margin: 5px;
  }
}

// XS
@media screen and (max-width: 600px) {
  .botoes {
    padding-bottom: 80px;
    margin-top: 0;
  }
}

// SM
@media screen and (max-width: 960px) and (min-width: 601px) {
  .botoes {
    padding-bottom: 90px;
  }
}

// MD
@media screen and (max-width: 1264px) and (min-width: 961px) {
  .botoes {
    padding-bottom: 110px;
  }
}

// LG
@media screen and (max-width: 1904px) and (min-width: 1265px) {
  .botoes {
    padding-bottom: 100px;
  }
}

// XL
@media screen and (min-width: 1905px) {
  .botoes {
    padding-bottom: 100px;
  }
}
</style>
